import React, { useState, useEffect } from "react";
import "./styles.css";
import Checkbox from "../Checkbox";
import storage from "../../services/storage";
import ApiServices from "../../services/apiServices";
import { toast } from "react-toastify";
import { IoCloseSharp } from "react-icons/io5";

const LiAceito = ({}) => {
  const [aceitar, setAceitar] = useState(false);
  const [trava, setTrava] = useState(false);

  const [fechar, setFechar] = useState(false);
  const [listaPopUp, setListaPopUp] = useState([]);
  const [verMais, setVerMais] = useState(0);
  const userId = storage.get("USUARIO")?.loginResponse?.profile?.userId;

  async function fnAceitarModal(regulamentoId, i, visualizou, aceite) {
    var objEnvio = {
      regulamentoId: regulamentoId,
      visualizou: visualizou,
      aceite: aceite,
    };

    try {
      let response = await ApiServices.apiPost(
        "regras/campanha/aceite",
        objEnvio
      );
      if (response.statusCode == 200) {
        setVerMais(verMais + 1);
        setAceitar(false);
        setListaPopUp((prev) =>
          prev.map((item, index) =>
            index === i ? { ...item, visualizeiFront: true } : item
          )
        );
      }
      setTrava(false);
    } catch (err) {
      setTrava(false);
      console.error("err", err);
    } finally {
      setTrava(false);
    }
  }

  async function fnListaPopUp() {
    if (storage.get("TOKEN") !== null) {
      try {
        let response = await ApiServices.apiGet(`regras/campanha/${userId}`);

        // Garante que response.data é um array antes de tentar usar forEach
        if (Array.isArray(response?.data)) {
          response.data.forEach((element) => {
            element.visualizeiFront = false;
          });

          if (response.data.length > 0) {
            setFechar(true);
          } else {
            setFechar(false);
          }
          setListaPopUp(response.data);
        } else {
          setFechar(false);
          setListaPopUp([]);
        }
      } catch (err) {
        // Exibe erro no console e garante que o modal não fique travado
        console.error("Erro ao buscar lista de popups:", err);
        setFechar(false);
        setListaPopUp([]);
      }
    }
  }

  useEffect(() => {
    fnListaPopUp();
  }, []);

  useEffect(() => {
    if (listaPopUp?.length === verMais) {
      setFechar(false);
    }
  }, [verMais]);

  return (
    <div>
      {fechar && (
        <div
          className="divModal"
          onClick={(e) => {
            const modalContent = document.querySelector(".conteudoModalHome");
            if (modalContent && !modalContent.contains(e.target)) {
              toast.warning(
                "Para seguir com a navegação no Amigo Leo é preciso aceitar o informativo"
              );
            }
          }}
        >
          {listaPopUp.map(
            (e, i) =>
              verMais === i &&
              e.visualizeiFront === false && (
                <div className="conteudoModalHome" key={i}>
                  <div
                    className="tituloModalHome d-flex justify-content-between "
                    style={{ fontWeight: 700 }}
                  >
                    <p>{e?.nome}</p>
                    {/*NAO =>>>>> UNICO CONTINUIO */}
                  </div>
                  <div className="textoModalHome">
                    <p>{e?.texto}</p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: e?.mensagem,
                      }}
                    />

                    {e.popUpComAceite == false && (
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn btn-warning mt-2"
                          onClick={() => {
                            !trava &&
                              fnAceitarModal(
                                e?.regulamentoId,
                                i,
                                e.visualizacaoSemAceite,
                                e.popUpComAceite
                              );
                            setTrava(true);
                          }}
                        >
                          OK, Ciente
                        </button>
                      </div>
                    )}
                  </div>

                  {/*SIM =>>>>> ACEITE */}
                  {e.popUpComAceite == true && (
                    <div>
                      <div className="radioModalMaisPremios">
                        <div
                          className="d-flex align-items-center "
                          onClick={() => {
                            setAceitar(!aceitar);
                          }}
                        >
                          <Checkbox status={aceitar == true} />

                          <span style={{ margin: 5 }}>Li e concordo</span>
                        </div>
                      </div>
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn btn-warning my-2"
                          disabled={!aceitar}
                          onClick={() => {
                            !trava &&
                              fnAceitarModal(
                                e?.regulamentoId,
                                i,
                                e.visualizacaoSemAceite || true,
                                e.popUpComAceite
                              );
                            setTrava(true);
                          }}
                        >
                          Continuar
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )
          )}
        </div>
      )}
    </div>
  );
};

export default LiAceito;
